module.exports = __webpack_public_path__ + "fonts/OpenSans-SemiBold.c98fd6a2.woff";